module.exports = __webpack_public_path__ + "img/hn.924e4722.svg";